module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"label":"查看各商品選項的評論","description":"*顯示的評論數量可能會因統計時間點不同而與實際數量有所差異。"}}')
  delete Component.options._Ctor
}
